import React, { FC } from 'react';
import { useEnvironment, WidgetProps } from '@wix/yoshi-flow-editor';
import { st, classes } from './Widget.st.css';
import { ViewModel } from '../controller/viewModel/viewModel';
import { Body } from './Body/Body';
import { WidgetViewModelProvider } from './hooks/useWidgetViewModel';
import { Header } from './Header/Header';

export type ControllerProps = {
  viewModel: ViewModel;
};

export const Widget: FC<WidgetProps<ControllerProps>> = ({ viewModel }) => {
  const environment = useEnvironment();

  return (
    <WidgetViewModelProvider value={viewModel}>
      <div
        className={st(classes.root, { isRTL: environment.isRTL })}
        data-hook="WixServices-wrapper"
      >
        <Header />
        <Body />
      </div>
    </WidgetViewModelProvider>
  );
};
